import { LoadingButton } from '@mui/lab';
import { Typography } from '@mui/material';
import Dialog from 'components/dialog/dialog';
import { useRenewSecretKeyMutation } from '../../api/user.api';
import { immediateToast } from 'utils/toast';
import useProfile from 'hooks/use-update-profile-query';

const RenewSecretKeyDialog = ({ open, onClose }: any) => {
    const [renewSecretKey, { isLoading }] = useRenewSecretKeyMutation();
    const { profile, update } = useProfile();

    const handleRenewSecretKey = () => {
        renewSecretKey()
            .unwrap()
            .then((res) => {
                if (!profile) return;

                update({ ...profile, secret_key: res.key });

                immediateToast('success', {
                    message: 'توکن وب سرویس جدید ایجاد شد',
                    timeout: 2000,
                });

                onClose();
            })
            .catch((error) => {
                immediateToast('error', {
                    message:
                        error?.data?.message ||
                        'بروزرسانی توکن وب سرویس انجام نشد. دوباره تلاش کنید.',
                    timeout: 3000,
                });
            });
    };

    return (
        <Dialog
            label="بروزرسانی توکن وب سرویس"
            open={open}
            onClose={onClose}
            disable={isLoading}
            icon={<i className="fa-light fa-rotate" />}
            type="warning"
            width="370px"
        >
            <Typography
                sx={{
                    color: 'text.secondary',
                    fontSize: 13,
                    lineHeight: 2,
                    textAlign: 'center',
                    px: 0.5,
                }}
            >
                با ایجاد توکن جدید، توکن فعلی بلافاصله نامعتبر می‌شود. از بروزرسانی
                توکن وب سرویس مطمئن هستید؟
            </Typography>

            <LoadingButton
                fullWidth
                loading={isLoading}
                variant="contained"
                color="warning"
                onClick={handleRenewSecretKey}
                sx={{
                    mt: 2.5,
                    minHeight: 40,
                    color: '#fff !important',
                    '&.Mui-disabled': {
                        color: 'rgba(255,255,255,.65) !important',
                    },
                }}
            >
                تایید و ایجاد توکن جدید
            </LoadingButton>
        </Dialog>
    );
};

export default RenewSecretKeyDialog;
